import { put, call } from "redux-saga/effects";
import { damagingNameConstants, alertConstants, authConstants } from "_constants";
import { damagingNameService } from "_services";
import { damagingNameActions } from "_actions";

export function* searchAdminDamagingPartiesSaga(action) {
  try {
    const { searchTerm } = action.payload;
    const response = yield call(damagingNameService.searchAdminDamagingParties, searchTerm);
    yield put(damagingNameActions.searchDamagingPartiesSuccess(response));
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({ type: authConstants.LOGOUT });
    }
    yield put(damagingNameActions.searchDamagingPartiesFailure(error.message));
    yield put({ type: alertConstants.ERROR, payload: { message: error.message } });
  }
}

export function* searchByClaimIdSaga(action) {
  try {
    const { claimId } = action.payload;
    const response = yield call(damagingNameService.searchByClaimId, claimId);
    yield put(damagingNameActions.searchByClaimIdSuccess(response));
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({ type: authConstants.LOGOUT });
    }
    yield put(damagingNameActions.searchByClaimIdFailure(error.message));
    yield put({ type: alertConstants.ERROR, payload: { message: error.message } });
  }
}

export function* searchInClaimsSaga(action) {
  try {
    const { damagingName } = action.payload;
    const response = yield call(damagingNameService.searchInClaims, damagingName);
    yield put(damagingNameActions.searchInClaimsSuccess(response));
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({ type: authConstants.LOGOUT });
    }
    yield put(damagingNameActions.searchInClaimsFailure(error.message));
    yield put({ type: alertConstants.ERROR, payload: { message: error.message } });
  }
}

export function* searchInContactsSaga(action) {
  try {
    const { name } = action.payload;
    const response = yield call(damagingNameService.searchInContacts, name);
    yield put(damagingNameActions.searchInContactsSuccess(response));
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({ type: authConstants.LOGOUT });
    }
    yield put(damagingNameActions.searchInContactsFailure(error.message));
    yield put({ type: alertConstants.ERROR, payload: { message: error.message } });
  }
}

export function* deleteDamagingPartiesSaga(action) {
  try {
    const { ids } = action.payload;
    const response = yield call(damagingNameService.deleteDamagingParties, ids);
    yield put(damagingNameActions.deleteDamagingPartiesSuccess(response));
    yield put({ type: alertConstants.SUCCESS, payload: { message: "Records deleted successfully" } });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({ type: authConstants.LOGOUT });
    }
    yield put(damagingNameActions.deleteDamagingPartiesFailure(error.message));
    yield put({ type: alertConstants.ERROR, payload: { message: error.message } });
  }
}

export function* updateClaimNamesSaga(action) {
  try {
    const { ids, newName } = action.payload;
    const response = yield call(damagingNameService.updateClaimNames, ids, newName);
    yield put(damagingNameActions.updateClaimNamesSuccess(response));
    yield put({ type: alertConstants.SUCCESS, payload: { message: "Claim records updated successfully" } });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({ type: authConstants.LOGOUT });
    }
    yield put(damagingNameActions.updateClaimNamesFailure(error.message));
    yield put({ type: alertConstants.ERROR, payload: { message: error.message } });
  }
}

export function* updateContactNamesSaga(action) {
  try {
    const { ids, newName } = action.payload;
    const response = yield call(damagingNameService.updateContactNames, ids, newName);
    yield put(damagingNameActions.updateContactNamesSuccess(response));
    yield put({ type: alertConstants.SUCCESS, payload: { message: "Contact records updated successfully" } });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({ type: authConstants.LOGOUT });
    }
    yield put(damagingNameActions.updateContactNamesFailure(error.message));
    yield put({ type: alertConstants.ERROR, payload: { message: error.message } });
  }
}
